import { boot } from 'quasar/wrappers';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

export default boot(({ app }) => {
  Bugsnag.start({
    apiKey: process.env.BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginVue()],
    appVersion: process.env.VERSION,
    releaseStage: process.env.RELEASE,
    notifyReleaseStages: ['production'],
  });

  app.use(Bugsnag.getPlugin('vue'));

  // Bugsnag.notify(new Error('Test error'));
});
